import React, { Component } from 'react'
import {
    CCard,
    CCardHeader,
    CCardBody,
    CCardFooter,
    CSelect,
    CTooltip,
    CButton,
    CRow,
    CCol,
    CPopover,
    CLink,
} from '@coreui/react';
import CIcon from '@coreui/icons-react';
import { helps } from 'src/_helpers';
import configs from 'src/appConfigs';
import Loading from 'src/containers/_loading';

class ProjectEmployees extends Component {

    constructor(props) {
        super(props);

        this.state = {
            project_employees: [],
            project_employee: {},
            area_id: '',
        }
        this.handleChange = this.handleChange.bind(this);
        this.handleChangeShift = this.handleChangeShift.bind(this);
        this.handleChangeArea = this.handleChangeArea.bind(this);
    }

    componentDidMount() {

    }

    handleChangeArea(e) {
        let area_id = e.target.value;
        this.setState({ area_id: area_id });
        // console.log(area_id)
    }

    handleChange(e, employee_id, maneuver_id) {
        const { project } = this.props;
        let project_employees = project.employees;
        let position_id = e.target.value;

        project_employees = project_employees.filter(_employee => _employee.employee_id !== employee_id);
        let project_employee = {
            employee_id: employee_id,
            maneuver_id: maneuver_id,
            position_id: position_id,
        };
        this.setState({ project_employee: project_employee });

        project_employees.push(project_employee);

        project['employees'] = project_employees;
        //console.log(project_employees);
        this.props.updateProject(project);
    }

    handleChangeShift(e, employee_id, maneuver_id, position_id) {
        const { project } = this.props;
        let project_employees = project.employees;
        let shift_id = e.target.value;

        project_employees = project_employees.filter(_employee => _employee.employee_id !== employee_id);
        let project_employee = {
            employee_id: employee_id,
            maneuver_id: maneuver_id,
            position_id: position_id,
            shift_id: shift_id
        };
        project_employees.push(project_employee);

        project['employees'] = project_employees;
        console.log(project_employees);
        this.props.updateProject(project);
    }

    async handleUpdateProjectEmployees(e, employee) {
        e.preventDefault();
        const { project } = this.props;
        let project_employees = project.employees.filter(_employee => _employee.employee_id !== employee.employee_id);
        project['employees'] = project_employees;
        await this.props.updateField(project, 'employees');
        this.props.history.push(`/employees/view/${employee.employee_id}#exit`)
    }

    render() {
        const { project, employees, positions } = this.props;
        let areas = !helps.isEmpty(project.areas) ? project.areas : [];
        let project_positions = !helps.isEmpty(positions) ? positions.filter(position => position.project_id === project.id) : [];
        if (!helps.isEmpty(project.employees) && project.employees.length > 0) {
            project.employees.sort((a, b) => { return a.fullname - b.fullname });
        }
        let is_default = (configs.default_project_id === project.id || project.id === 'IfUWdJDYLB2Q4Y9Gwt8A') ? true : false;

        let project_employees = !helps.isEmpty(project.employees) ? project.employees : [];
        if (!helps.isEmpty(this.state.area_id)) {
            //console.log(this.state.area_id)
            let area_positions = positions.filter(_position => _position.area_id === this.state.area_id)
            //console.log(area_positions)
            if (!helps.isEmpty(project_employees)) {
                project_employees = project_employees.filter((_employee) => {
                    let employee_position = helps.getItemFromArr(area_positions, _employee.position_id);
                    if (helps.isEmpty(employee_position)) return false;
                    else return true;
                })
            }
        }

        if (helps.isEmpty(project)) {
            return (
                <Loading></Loading>
            );
        }

        return (
            <CCard>
                <CCardHeader>
                    <CRow>
                        <CCol>
                            Danh Sách Nhân Sự Trực Mục Tiêu
                        </CCol>
                        <CCol className={'text-right'}>
                            <CSelect
                                name="area_id"
                                id="input-area_id"
                                value={this.state.area_id}
                                onChange={(e) => { this.handleChangeArea(e) }}
                            >
                                <option value={''}> - Khu vực - </option>
                                {!helps.isEmpty(areas) && areas.map(area => {
                                    return (
                                        <option key={area.id} value={area.id}>{area.name}</option>
                                    );
                                })}
                            </CSelect>
                        </CCol>
                    </CRow>
                </CCardHeader>
                <CCardBody>
                    <table className='table'>
                        <thead>
                            <tr>
                                <th style={{ width: '5%' }}>#</th>
                                <th>Họ & Tên</th>
                                <th>Chức vụ</th>
                                <th style={{ width: '20%' }}>Vị trí trực</th>
                                <th style={{ width: '20%' }}>Ca trực</th>
                                <th style={{ width: '20%' }}>Khu vực</th>
                                {is_default && <th className='text-center'>X</th>}
                            </tr>
                        </thead>
                        <tbody>
                            {helps.isEmpty(project_employees) && <tr><td colSpan={5}></td></tr>}
                            {!helps.isEmpty(project_employees) && project_employees.map((_employee, cnt) => {
                                let employee = helps.getItemFromArr(employees, _employee.employee_id, 'employee_id');
                                let position = helps.getItemFromArr(positions, _employee.position_id);
                                let shift = helps.getItemFromArr(position.shifts, _employee.shift_id);
                                let area = helps.getItemFromArr(areas, position.area_id);
                                var birthdate = '';
                                if (employee.birthdate) {
                                    birthdate = employee.birthdate.toLocaleDateString();
                                }
                                return (
                                    <tr key={'project-employees-' + _employee.employee_id}>
                                        <td>{cnt + 1}</td>
                                        <td>
                                            <CLink className="text-dark" onClick={() => { this.props.history.push(`/employees/view/${employee.employee_id}`) }}>
                                                <CPopover
                                                    content={
                                                        <div>
                                                            <div className='mb-1'><b>{employee.fullname}</b></div>
                                                            <div>
                                                                MSNV: <b>{employee.employee_id}</b>
                                                            </div>
                                                            <div>
                                                                Năm sinh: <b>{birthdate}</b>
                                                            </div>
                                                            <div>
                                                                Số ĐT: <b>{employee.phone}</b>
                                                            </div>
                                                        </div>
                                                    }
                                                >
                                                    <div><b>{employee.fullname}</b><div>({employee.employee_id})</div></div>
                                                </CPopover>

                                            </CLink>
                                        </td>
                                        <td>{configs.positions[employee.position]}</td>
                                        <td>
                                            <CTooltip content={<>{position.name} {area ? ' - ' + area.name : ''} {position.description ? ' - ' + position.description : ''}</>}>
                                                <CSelect
                                                    name='position_id'
                                                    value={_employee.position_id}
                                                    onChange={(e) => { this.handleChange(e, _employee.employee_id, _employee.maneuver_id) }}
                                                >
                                                    <option value=''>-- Vị trí --</option>
                                                    {project_positions && project_positions.map((position) => {
                                                        var description = '';
                                                        let position_area = helps.getItemFromArr(areas, position.area_id);
                                                        if (!helps.isEmpty(position_area)) {
                                                            description = ' - ' + position_area.name;
                                                        }
                                                        if (!helps.isEmpty(position.description)) {
                                                            description = ' - ' + position.description;
                                                        }
                                                        return (
                                                            <option value={position.id} key={_employee.employee_id + 'position_' + position.id}>
                                                                {position.name} {description}
                                                            </option>
                                                        );
                                                    })}
                                                </CSelect>
                                            </CTooltip>
                                        </td>
                                        <td>
                                            <CTooltip content={<>{shift.label} - {shift.start}-{shift.end}({shift.duration}/24)</>}>
                                                <CSelect
                                                    name='shift_id'
                                                    value={_employee.shift_id}
                                                    onChange={(e) => { this.handleChangeShift(e, _employee.employee_id, _employee.maneuver_id, position.id) }}
                                                >
                                                    <option value=''>-- Ca --</option>
                                                    {position.shifts && position.shifts.map((shift) => {
                                                        return (
                                                            <option value={shift.id} key={_employee.employee_id + 'shift_' + shift.id}>
                                                                {shift.label} - {shift.start}-{shift.end}({shift.duration}/24)
                                                            </option>
                                                        );
                                                    })}
                                                </CSelect>
                                            </CTooltip>
                                        </td>
                                        <td>
                                            {area.name}
                                        </td>
                                        {is_default &&
                                            <td className='text-center'>
                                                <CTooltip
                                                    content='Làm thủ tục Thôi việc'
                                                >
                                                    <CButton
                                                        color="secondary"
                                                        size="sm"
                                                        className="ml-1"
                                                        onClick={(e) => { this.handleUpdateProjectEmployees(e, _employee) }}
                                                    >
                                                        <CIcon name="cil-exit-to-app"></CIcon>
                                                    </CButton>
                                                </CTooltip>
                                            </td>
                                        }
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </CCardBody>
                <CCardFooter>
                    {project.employees && <>Tổng số Nhân Viên: <b>{project_employees.length}</b></>}
                </CCardFooter>
            </CCard>
        )
    }
}
export default ProjectEmployees;
